import { render, staticRenderFns } from "./StockPicturesActions.vue?vue&type=template&id=969e0df6&"
import script from "./StockPicturesActions.vue?vue&type=script&lang=js&"
export * from "./StockPicturesActions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports